import OnboardingProgressBar from './OnboardingProgressBar'

export default OnboardingProgressBar
// eslint-disable-next-line import/export
export * from './OnboardingProgressBar'
